import React from 'react';

import { Dialog, HStack, Text, VisuallyHidden } from '@betterment/samba-react';
import { ErrorBoundary } from '@betterment/shared-components';

import AiOrb from './assets/icon_ai_orb.svg';
import { GradientBorderBox } from './components/GradientBorderBox';
import { Content } from './Content';

import { IdempotencyProviderWithFeatureRegistry } from '../../RetailApp/graphql/idempotency/IdempotencyProviderWithFeatureRegistry';

export const AccountRecommendationModal: React.FC<{ compact: boolean }> = ({ compact }) => {
  const width = compact ? undefined : 'space.100%';
  return (
    <Dialog>
      <Dialog.Trigger asChild={true}>
        <GradientBorderBox borderRadius={20} role="button" tabIndex={0} style={{ width }}>
          <HStack
            css={{
              px: compact ? 'space.100' : 'space.200',
              py: 'space.100',
              gap: 'space.50',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
          >
            <img src={AiOrb} alt="AI Icon" />
            <Text variant="text50" color="text" css={{ fontWeight: 'medium' }}>
              {compact ? 'Get recommendation' : 'Get a personalized recommendation'}
            </Text>
          </HStack>
        </GradientBorderBox>
      </Dialog.Trigger>
      <Dialog.Content size="large" css={{ p: 'space.400', minWidth: '400px', minHeight: '200px', maxWidth: '800px' }}>
        <VisuallyHidden>
          <Dialog.Title>Account recommendation</Dialog.Title>
          <Dialog.Description>Your account recommendation</Dialog.Description>
        </VisuallyHidden>
        <ErrorBoundary fallbackType="partial" feature="account recommendation" owner="agents">
          <IdempotencyProviderWithFeatureRegistry featureName="createAccountRecommendation">
            <Content />
          </IdempotencyProviderWithFeatureRegistry>
        </ErrorBoundary>
      </Dialog.Content>
    </Dialog>
  );
};
